import { LocationScope, LocationVarInheritance, MergedLocationVar } from "@swivl-mono/types";
import { Switch } from "@swivl-mono/ui";

import { WorksheetComponentLabel } from "../Label/WorksheetComponent.Label";
import "./WorksheetComponent.scss";

interface Props {
  className: string;
  label?: string;
  variable: MergedLocationVar;
  type: LocationScope;
  isEditing: boolean;
  disableReverting?: boolean;
  saveVariable: (value: string) => void;
  customize(): void;
  deleteVariable(): void;
  isLoading: boolean;
  tooltip?: string;
}

export function WorksheetComponentSwitch(props: Props) {
  const { label, type, variable, isEditing, disableReverting, saveVariable, deleteVariable } = props;

  const setValue = (e: any) => {
    saveVariable(e.target.checked ? "1" : "0");
  };

  const value = variable.value === "1" || variable.value === "true" ? true : false;

  if (isEditing) {
    return (
      <div className={`WorksheetComponent WorksheetComponentSwitch isEditing inheritance_${variable.inheritance} ${props.className}`}>
        {variable.inheritance === LocationVarInheritance.NONE ? (
          <Switch on={value} onChange={setValue} />
        ) : (
          <div className="parentSwitch" onClick={props.customize}>
            <Switch on={value} onChange={setValue} readOnly={true} readOnlyHoverOverlay="Customize" />
          </div>
        )}
        <WorksheetComponentLabel
          key={variable.inheritance + variable.key + variable.id}
          text={label}
          inheritance={variable.inheritance}
          isEditing={isEditing}
          type={type}
          canRevert={!disableReverting}
          isLoading={props.isLoading}
          deleteVariable={deleteVariable}
          inline={true}
          tooltip={props.tooltip}
        />
      </div>
    );
  }

  return (
    <div className={`WorksheetComponent WorksheetComponentSwitch inheritance_${variable.inheritance} ${props.className}`}>
      <WorksheetComponentLabel
        key={variable.inheritance + variable.key + variable.id}
        text={label}
        inheritance={variable.inheritance}
        isEditing={isEditing}
        type={type}
        canRevert={!disableReverting}
        isLoading={props.isLoading}
        deleteVariable={deleteVariable}
        tooltip={props.tooltip}
      />
      <div className="valueText">{value ? "Yes" : "No"}</div>
    </div>
  );
}
